let config = {
  webviewId: undefined,
  iframeViewId: undefined,
  unitId: undefined,
  viewMap: undefined,
  nativeBroadcastAPI:'VideoBridge/broadcast',
  nativeBroadcastParamFilter:d=>d,
  callNative: undefined,

  setConfig({
      webviewId,
      iframeViewId,
      unitId,
      viewMap,
      rootWebviewId,
      nativeBroadcastAPI,
      nativeBroadcastParamFilter,
      callNative
  }){
      unitId && (config.unitId = unitId);
      iframeViewId && (config.iframeViewId = iframeViewId);
      (webviewId || rootWebviewId) && (config.webviewId = webviewId || rootWebviewId)
      viewMap && (config.viewMap = viewMap)
      nativeBroadcastAPI && (config.nativeBroadcastAPI = nativeBroadcastAPI)
      nativeBroadcastParamFilter && (config.nativeBroadcastParamFilter = nativeBroadcastParamFilter)
      callNative && (config.callNative = callNative)
  }
}

export default config